import React from 'react';
import { withRouter } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import { SystemText } from 'e4shared';
import { e4Format, e4Formats } from 'helpers/dates';

export const Post = props => {
    const { data, history } = props;

    const st = (s, x) => SystemText(`Search/Results/Blog/${s}`, x);

    return (
        <div className="search-result box" onClick={() => history.push(`/blog/post/${data.id}`)}>
            <div className="image-holder hidden-xs">
                <BlobImage folder="blog_Image" src={data.image} />
            </div>
            <div>
                <label className="label label-primary">
                    <i className="mr10 fa fa-comments" />
                    {st('Title')}
                </label>
                <h2>{data.name}</h2>
                <p>{data.summary}</p>
                <span>
                    {st('By')} {data.extras2}
                </span>
                <span>{e4Format(data.extras3, e4Formats.urlSafe)}</span>
                <span>
                    <i className="fa fa-comments" /> {data.extras4}
                </span>
                <span>
                    <i className="fa fa-thumbs-up" /> {data.extras5}
                </span>
            </div>
        </div>
    );
};

export default withRouter(Post);
